import * as React from 'react';
import styled from 'styled-components';
import theme from 'theme';
import { RiskRatingClass } from 'components/context/types';

const RiskRating = styled.div`
    display: flex;
`;

const RiskBall = styled.div<{ filled: boolean; height?: number }>`
    border-radius: 50%;
    width: ${p => (p.height ? `${p.height}px` : '30px')};
    height: ${p => (p.height ? `${p.height}px` : '30px')};
    margin: ${p => (p.height ? `0 ${p.height / 3}px` : '0 10px')};
    opacity: ${p => (p.filled ? 1 : 0.3)};
    transform: ${p => (p.filled ? 'scale(1.15)' : 'scale(1)')};

    &:first-of-type {
        border: 4px solid ${theme.colors.red_bright};
        background-color: ${p =>
            p.filled ? theme.colors.red_bright : 'transparent'};
    }
    &:nth-of-type(2) {
        border: 4px solid ${theme.colors.yellow_bright};
        background-color: ${p =>
            p.filled ? theme.colors.yellow_bright : 'transparent'};
    }
    &:nth-of-type(3) {
        border: 4px solid ${theme.colors.green_bright};
        background-color: ${p =>
            p.filled ? theme.colors.green_bright : 'transparent'};
    }
`;

interface Props {
    riskRatingClass: RiskRatingClass;
    height?: number;
}

export default function RiskRatingBalls({ riskRatingClass, height }: Props) {
    const riskColors = [
        RiskRatingClass.RED,
        RiskRatingClass.YELLOW,
        RiskRatingClass.GREEN
    ];
    return (
        <RiskRating>
            {riskColors.map((riskColor: RiskRatingClass) => {
                return (
                    <RiskBall
                        key={riskColor}
                        filled={riskColor === riskRatingClass}
                        height={height}
                    />
                );
            })}
        </RiskRating>
    );
}
